import { TransactionModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/charge-hub-service-lib/src/wrapper/outputs/transaction/paginated/transaction.model';
import { IdentifiedColumnDef } from '@tanstack/react-table';

import { TransactionListChargePointCell } from './transaction-list-charge-point.cell';
import { TransactionListChargePointHeader } from './transaction-list-charge-point.header';

export const TransactionListChargePointColumn: IdentifiedColumnDef<
  TransactionModel,
  TransactionModel['chargePoint']
> = {
  enableSorting: false,
  header: TransactionListChargePointHeader,
  cell: TransactionListChargePointCell,
  meta: { maxWidth: '110px', width: '80px', minWidth: '60px' },
};
